import styled from "styled-components";

export const CertWrapper = styled.div<{ isApp: number | null }>`
  width: 100%;
  height: 100vh;
  background-color: white;
  z-index: 1000;
  margin-top: 48px;
  padding: 20px 24px;
  padding-top: ${(p) => (p.isApp ? `${p.isApp + 20}px` : "20px")};
`;
export const CertTitle = styled.div`
  color: ${(p) => p.theme.color.black500};

  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 33.6px */
`;

export const CertGenderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const CertGenderItem = styled.div<{ isSelected: boolean }>`
  flex: 1;
  height: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);

  > img {
    width: 90px;
    height: 90px;
  }

  > span {
    color: ${(p) => (p.isSelected ? "#121212" : "#808080")};
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const CertInputWrapper = styled.div`
  margin-top: 32px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  input {
    padding: 10px 0;
    width: 100%;
    border: none;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${(p) => p.theme.color.black200};
    outline: none;
    text-align: left;

    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    transition: all 0.3s;

    &:focus {
      border-bottom-color: ${(p) => p.theme.color.purple300};
    }

    &::placeholder {
      color: ${(p) => p.theme.color.black200};
    }
  }
`;

export const CertBottomButton = styled.div`
  width: 100%;
  height: 56px;
  border-radius: 8px;
  background: var(--Purple-300, #6436e7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 30px;
`;

export const CertSurveyBottomButton = styled.div<{
  isSelected: boolean;
}>`
  position: fixed;
  bottom: 48px;
  left: 50%;
  transform: translateX(-50%);

  width: calc(100% - 48px);
  height: 56px;
  border-radius: 8px;
  background: ${(p) => (p.isSelected ? "#6436e7" : "#D1C3F8")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 30px;
`;

export const CertBottomInfo = styled.div`
  color: var(--Black-300, #808080);
  text-align: center;

  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 13px;
`;

export const CertUsedPubButtonWrapper = styled.div`
  margin-top: 30px;
  diaplay: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CertExperienceButtonWrapper = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 6px;
`;

export const CertExperienceButton = styled.div<{ isSelected: boolean }>`
  width: 100%;
  height: 56px;
  border-radius: 8px;
  background: ${(p) => (p.isSelected ? "#6436e7" : "#f0f0f0")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => (p.isSelected ? "#FFF" : "#808080")};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const CertUsedPubButton = styled.div<{ isSelected: boolean | null }>`
  width: 100%;
  height: 56px;
  border-radius: 8px;
  background: ${(p) =>
    p.isSelected ? "#6436e7" : p.isSelected === null ? "#f0f0f0" : "#f0f0f0"};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) =>
    p.isSelected ? "#FFF" : p.isSelected === null ? "#808080" : "#808080"};
`;

export const CertRouteButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
`;

export const CertRouteButton = styled.div<{ isSelected: boolean }>`
  width: 100%;
  height: 56px;
  border-radius: 8px;
  background: ${(p) => (p.isSelected ? "#6436e7" : "#f0f0f0")};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: ${(p) => (p.isSelected ? "#FFF" : "#808080")};
  padding: 0 16px;
  margin-bottom: 8px;
`;

export const CertRouteInput = styled.input`
  width: 100%;
  height: 40px;
  border: none;
  outline: none;
  border-bottom: 2px solid var(--Black-200, #b7b7b7);
  padding: 10 0px;

  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 8px;
`;
